import { UniqueColumnValuesResponse } from './dto';
import axiosServices from 'utils/axios';

export const getUniqueColumnValues = async (fileId: number, sheetId: number, columnName: string): Promise<string[]> => {
    const response = await axiosServices.get<UniqueColumnValuesResponse>(
        `/insideFifa/generic-tables/files/${fileId}/sheets/${sheetId}/columns/${columnName}/unique-values`
    );
    return response.data.values;
};